export default __webpack_public_path__ + "static/media/2.82f66b1c.svg";